<template lang="pug">
.About
  LerpScroll.content
    h1.big-title María©erdán
    // p.intro Redactora Creativa en publicidad actualmente trabajando en Barcelona. Para colaboraciones, consultas, <a href="https://www.youtube.com/watch?v=5Jd9AmepgdM" target="_blank" rel="noopener">chorradas</a> o <a href="https://vimeo.com/user103999587" target="_blank" rel="noopener">spam</a>, aquí estoy. También en <a href="https://linkedin.com" target="_blank" rel="noopener">LinkedIn</a> & <a href="https://instagram.com" target="_blank" rel="noopener">Instagram.</a>
    p.intro Creative advertising copywriter currently working in Barcelona. For collaborations, queries or <a href="https://www.youtube.com/watch?v=5Jd9AmepgdM" target="_blank" rel="noopener">nonsense</a> you can find me <a href="https://www.google.es/maps/place/Barcelona/@41.3947688,2.0787278,12z/data=!3m1!4b1!4m5!3m4!1s0x12a49816718e30e5:0x44b0fb3d4f47660a!8m2!3d41.3850639!4d2.1734035" target="_blank" rel="noopener">here</a>. And also on <a href="https://es.linkedin.com/in/mar%C3%ADa-cerd%C3%A1n-mart%C3%ADnez-baa33163" target="_blank" rel="noopener">LinkedIn</a> & <a href="https://instagram.com/mariacerdan" target="_blank" rel="noopener">Instagram.</a>
    div.mariaImage
      p.title Achievements
      img.maria-pp(src="@/assets/images/maria.jpg")
      .lists
        ul.awards
          h2 Awards
          li(v-for="award in aboutData.awards")
            strong {{award.award}}
            p {{award.for}}
            p ({{award.at}})
        ul.experience
          h2 Experience
          li(v-for="experience in aboutData.experience")
            strong(v-if="experience.job") {{ experience.job }}
            strong(v-if="experience.at") {{ experience.at }}
            p ({{experience.date}})
        ul.education
          h2 Education
          li(v-for="study in aboutData.education")
            strong {{ study.grad }}
            p ({{study.place}})
            p {{study.date}}
        ul.talks
          h2 Talks
          li(v-for="talks in aboutData.talks")
            strong {{ talks.place }}
            p ({{talks.talk}})
            p {{talks.who}}
</template>

<script>
import LerpScroll from '@/components/LerpScroll'
import { TimelineLite, Power4 } from 'gsap'

export default {
  name: 'home',
  components: { LerpScroll },
  data() {
    return {
      mobile: window.innerWidth <= 900,
      titleText: '',
      currentSection: 'awards',
      aboutData: {
        awards: [
          {
            award: '2019 Gold best awards',
            for: 'Kas',
            at: 'Commercial'
          },
          {
            award: '2019 Silver Premios Impacto',
            for: 'Lays Gourmet',
            at: '&Rosàs'
          },
          {
            award: '2018 Silver Laus',
            for: 'Martin Códax Gráficas',
            at: '&Rosàs'
          },
          {
            award: '2018 CdeC Bronze',
            for: 'Martin Códax Gráficas',
            at: '&Rosàs'
          },
          {
            award: '2018 Gold Best Awards',
            for: 'Martin Códax Anuncio',
            at: '&Rosàs'
          },
          {
            award: '2016 Bronze Sol',
            for: 'Best Climate In The World. Vaho Taggers',
            at: 'BBDO'
          }
        ],
        experience: [
          { at: 'Currently at &Rosàs', date: '2016 - Now' },
          {
            job: 'Currently creativity professor at LaBasad',
            date: '2018 - Now'
          },
          { at: 'Creative advertising professor at Seeway', date: '2018' },
          { at: 'Dec BBDO', date: 'Sep 2015 - Jul 2016' },
          { at: 'Evil Love', date: 'Abril 2013 - Dic 2013' }
        ],
        education: [
          {
            grad: 'Screenwriting for television series',
            place: 'Showrunners. Barcelona.',
            date: '2019 - 2020'
          },
          {
            grad: 'Master. Graphic Design and Art Direction',
            place: 'IDEP Barcelona',
            date: '2016 - 2017'
          },
          {
            grad: 'Degree in Advertising and Public Relations',
            place: 'Autónoma Barcelona',
            date: '2016 - 2017'
          }
        ],
        talks: [
          {
            place: 'Talk at Primavera Sound 2018',
            talk: 'Music in Advertising',
            who: '&Rosàs & Thertytwo Music'
          },
          {
            place: 'Montserrat School',
            talk: 'How to Build Brands',
            who: '&Rosàs'
          }
        ]
      }
    }
  },
  methods: {
    // splitTitle() {
    //   const title = this.$el.querySelector('.big-title')
    //   this.titleText = title.textContent
    //   title.textContent = ''
    //   this.titleText.split(' ').forEach(word => {
    //     const wordEl = document.createElement('div')
    //     wordEl.classList.add('word')
    //     word.split('').forEach(letter => {
    //       const innerSpan = document.createElement('span')
    //       const outerSpan = document.createElement('span')
    //       const spaceBreak = document.createElement('br')
    //       innerSpan.classList.add('inner')
    //       outerSpan.classList.add('outer')
    //       if (letter === ' ') {
    //         letter = ''
    //         innerSpan.style.marginRight = '1.25em'
    //       }
    //       innerSpan.textContent = letter
    //       outerSpan.append(innerSpan)
    //       wordEl.append(outerSpan)
    //       if (this.mobile && outerSpan.textContent === '©') {
    //         wordEl.insertBefore(spaceBreak, outerSpan)
    //       }
    //     })
    //     title.append(wordEl)
    //   })
    // }
  },
  mounted() {
    // this.splitTitle()
    this.$emit('navigationName', 'about')
    window.addEventListener('resize', () => {
      this.mobile = window.innerWidth <= 900
    })

    const tl = new TimelineLite()
    tl.staggerFrom(
      '.big-title',
      1,
      { x: -100, autoAlpha: 0, ease: Power4.easeOut },
      0.2
    )
      .from('.title', 1, { y: 900, aufromAlpha: 0, ease: Power4.easeOut }, 0.3)
      .from(
        '.intro, .lists',
        1,
        { x: -100, autoAlpha: 0, ease: Power4.easeOut },
        0.4
      )
      .from('.maria-pp', 1, { x: -50, autoAlpha: 0, ease: Power4.easeOut }, 1)
  },
  beforeRouteLeave(to, from, next) {
    const outTL = new TimelineLite({ onComplete: next })
    outTL
      .staggerTo(
        '.big-title',
        1,
        { x: -100, autoAlpha: 0, ease: Power4.easeInOut },
        0.1
      )
      .to(
        '.title',
        1,
        { y: 900, opacity: 0, aufromAlpha: 0, ease: Power4.easeInOut },
        0.2
      )
      .to(
        '.intro, .lists',
        1,
        { x: -100, autoAlpha: 0, ease: Power4.easeInOut },
        0.2
      )
      .to('.maria-pp', 1, { x: -50, autoAlpha: 0, ease: Power4.easeInOut }, 0.3)
  }
}
</script>

<style lang="scss">
.About {
  a {
    color: black;
  }
  .content {
    color: black;
    @include grid(1, 6);
    box-sizing: content-box;
    padding: 6.2rem 0;

    @include desktop {
      @include grid(2, 6);
    }

    .big-title {
      font-size: $fs-xl;
      line-height: 1;
      @include grid-child(0, 6);
      margin: 0 0 2rem 0;

      @media screen and (min-width: 900px) and (max-width: 1023px) {
        font-size: $fs-xxl;
      }

      @media screen and (min-width: 1024px) {
        @include grid-child(0, 6);
        font-size: $fs-xxxl;
      }

      .word {
        display: block;

        .outer {
          display: inline-block;
          overflow: hidden;
          height: 1em;

          .inner {
            display: block;
          }
        }
      }
    }

    .mariaImage {
      display: grid;
      grid-template-columns: $fs-xl auto;
      grid-template-rows: auto;
      grid-template-areas:
        'img img'
        'title info';

      @include desktop {
        grid-template-columns: $fs-xxxl auto;
        grid-template-areas:
          'title img'
          'title info';
      }
    }

    .title {
      /* @include grid-child(0, 1); */
      width: auto;
      font-size: $fs-xl;
      line-height: 1.2;
      font-weight: bold;
      transform-origin: top right;
      transform: rotate(90deg);
      padding-left: 2rem;

      @include desktop {
        grid-area: title;
        font-size: $fs-xxxl;
      }
    }

    .maria-pp {
      height: getWidth(8 * 0.56, $margins-m);
      object-fit: cover;
      object-position: top;
      margin-top: 2rem;
      grid-area: img;

      @include desktop {
        margin-left: 2.5rem;
        height: getWidth(5 * 0.56, $margins-d);
      }
    }

    .intro {
      font-weight: normal;
      @include grid-child(0, 6);
      width: 76vw;

      @include desktop {
        @include grid-child(0, 5);
        width: 50vw;
      }
    }

    .lists {
      grid-area: info;
      margin-left: 1.5rem;
      margin-top: 1rem;
      line-height: 1;

      @include desktop {
        display: flex;
        margin-left: 2.5rem;
        margin-top: 2rem;
      }

      ul {
        list-style: none;
        padding: 0;
        margin-right: $grid-gap;
        margin-bottom: 4rem;
        font-size: $fs;

        @include desktop {
          font-size: $fs-s;
          @include grid-child(0, 1);
        }

        li {
          line-height: 1.4em;
          margin-top: 1em;

          @include desktop {
            font-size: $fs-s;
            line-height: 1.7em;
          }

          p {
            font-size: $fs-s;
            margin: 0;
          }
        }
      }
    }
  }
}
</style>
